import { useSeo } from "@/hooks/useSeo";
import JsonLd from "@/components/base/JsonLd";
import { posts, hotRanking } from "@/mocks/posts";
import { faqs } from "@/mocks/faqs";
import HomeHero from "./components/HomeHero";
import NewsGrid from "./components/NewsGrid";
import CategoryGrid from "./components/CategoryGrid";
import TrendingSection from "./components/TrendingSection";
import HomeFaq from "./components/HomeFaq";

const ORIGIN = "https://ymw88.top";

export default function Home() {
  useSeo({
    title: "黑吃瓜网 - 今日爆料 新瓜汇总 热门猛料持续更新",
    description:
      "黑吃瓜网每日更新今日爆料与新瓜汇总，整理娱乐圈热门话题、网友讨论与后续进展，分类检索加热度排序，吃瓜群众都在这里蹲更新。",
    keywords: "黑吃瓜网,今日爆料,新瓜汇总,热门猛料,娱乐话题整理",
    path: "/",
  });

  const featured = posts[0];
  const latest = posts.slice(1, 5);

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "黑吃瓜网",
      url: `${ORIGIN}/`,
      description: "娱乐话题爆料合集与今日新瓜汇总资讯站",
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: {
          "@type": "EntryPoint",
          urlTemplate: `${ORIGIN}/breaking?q={search_term_string}`,
        },
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "黑吃瓜网",
      url: `${ORIGIN}/`,
      email: "hi@heichigua.example.com",
      description: "专注娱乐话题整理的吃瓜资讯站，提供今日爆料、新瓜汇总与热门猛料更新。",
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "今日爆料与新瓜汇总",
      itemListElement: hotRanking.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
        url: `${ORIGIN}/post/${item.id}`,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <>
      <JsonLd data={jsonLd} />
      <HomeHero featured={featured} latest={latest} />
      <NewsGrid />
      <CategoryGrid />
      <TrendingSection />
      <HomeFaq />
    </>
  );
}